export type WalletPanelDeepLink =
  | "send"
  | "add"
  | "receive"
  | "more"
  | "settings"
  | "subscriptions"
  | "run"
  | "storage"
  | "market"
  | "workspace";

const WALLET_PANEL_DEEP_LINKS = new Set<WalletPanelDeepLink>([
  "send",
  "add",
  "receive",
  "more",
  "settings",
  "subscriptions",
  "run",
  "storage",
  "market",
  "workspace",
]);

export function walletPanelFromSearch(search: string): WalletPanelDeepLink | null {
  const panel = new URLSearchParams(String(search || "")).get("panel")?.trim().toLowerCase();
  return panel && WALLET_PANEL_DEEP_LINKS.has(panel as WalletPanelDeepLink)
    ? panel as WalletPanelDeepLink
    : null;
}

export function resolveWalletTopupWorkspace(
  activeWorkspaceId: string | null | undefined,
  requestedWorkspaceId?: string | null,
) {
  const active = String(activeWorkspaceId || "").trim();
  const requested = String(requestedWorkspaceId || "").trim();
  if (!active) throw new Error("Select a workspace before buying credits.");
  if (requested && requested !== active) {
    throw new Error(
      "This credit link is for a different workspace. Switch to that workspace before continuing.",
    );
  }
  return active;
}

export function walletTopupReturnPath(workspaceId: string) {
  const workspace = String(workspaceId || "").trim();
  if (!workspace) throw new Error("A workspace is required for the credit checkout return path.");
  return `/wallet?panel=add&workspace_id=${encodeURIComponent(workspace)}`;
}
